import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import ProfileContent from '../../components/Pages/Profile';

const { displayName } = config;

export default function Profile(): React.ReactElement {
  document.title = `${displayName}: Profile`;

  return (
    <Layout>
      <ProfileContent />
    </Layout>
  );
}
